import {
    useEffect,
    useState
} from "react";

import PdfView
    from "../../component/pdfView";

import DocxLabView
    from "../../component/docxLabView";

import {
    useParams
} from "react-router-dom";

import {
    getBySlug,
    getReaderMeta
} from "../../api/myBook";

import {
    Empty,
    message,
    Spin
} from "antd";

import {
    useDevice
} from "../../hooks";


export default function BookDetail() {

    const param =
        useParams();

    const {
        isMobile
    } = useDevice();

    const [book, setBook] =
        useState([]);

    const [readerType, setReaderType] =
        useState(null);

    const [detecting, setDetecting] =
        useState(true);

    const user =
        JSON.parse(
            localStorage.getItem(
                "user"
            )
        );


    useEffect(() => {

        const query =
            `user_id=${user?.user_id}`;

        getBySlug(
            param?.slug,
            query,
            setBook,
            message
        );

    }, []);


    useEffect(() => {

        if (
            !param?.slug ||
            !user?.user_id
        ) {
            setDetecting(false);
            return;
        }

        let active =
            true;

        setDetecting(true);

        getReaderMeta(
            param.slug,
            user.user_id
        )
            .then(
                response => {

                    if (!active) {
                        return;
                    }

                    setReaderType(
                        response?.data?.kind ||
                        "pdf"
                    );
                }
            )
            .catch(
                error => {

                    console.log(
                        "reader meta error:",
                        error
                    );

                    /*
                     * Neu metadata loi,
                     * giu co che PDF cu de khong lam mat sach.
                     */
                    if (active) {
                        setReaderType(
                            "pdf"
                        );
                    }
                }
            )
            .finally(
                () => {

                    if (active) {
                        setDetecting(
                            false
                        );
                    }
                }
            );

        return () => {
            active = false;
        };

    }, [
        param?.slug,
        user?.user_id
    ]);


    if (
        book?.data?.length <= 0
    ) {
        return (
            <Empty />
        );
    }


    if (detecting) {
        return (
            <div
                className="
                    min-h-[60vh]
                    flex
                    items-center
                    justify-center
                "
            >
                <Spin size="large" />
            </div>
        );
    }


    const title =
        book?.data?.[0]?.product_name ||
        "Tài liệu";


    if (
        readerType ===
        "docx"
    ) {
        return (
            <DocxLabView
                slug={
                    param?.slug
                }
                title={
                    title
                }
            />
        );
    }


    /*
     * PDF VA CAC FILE CU:
     * GIU NGUYEN CO CHE DOC HIEN TAI.
     */
    return (
        <section
            className={`
                max-w-screen-2xl
                mx-auto
                ${isMobile
                    ? ""
                    : "my-5"
                }
            `}
        >
            <PdfView
                url={
                    JSON.parse(
                        book?.data?.[0]
                            ?.product_image
                    )
                        ?.filter(
                            item =>
                                item.type ===
                                "file"
                        )
                        ?.[0]
                        ?.data
                }
                title={
                    title
                }
            />
        </section>
    );
}
